import React, { useState, useCallback, useEffect } from 'react';
import Skeleton from '@mui/material/Skeleton';
import { LoginSocialFacebook } from 'reactjs-social-login';

//Components
import BannerTerrapuntosDetail from './BannerTerrapuntosDetail';
import Alert from '../../Alert';

//Queries
import getGlobal from '../../Queries/getGlobal';
import postGloba from '../../Queries/postGlobal';

//Styles
import styles from './index.module.sass';

import FBLogo from '../../../images/facebook-logo-for-button.png';

const urlImage =
  'https://webimages.terramarbrands.com.mx/webpage/terrapuntos/icono-moneda-estrellas.png';
const urlImageStar =
  'https://webimages.terramarbrands.com.mx/webpage/terrapuntos/icono-estrella.png';

export default function TerrapointsDetail(props) {
  const { device, getCookie, setSessionMessage } = props;
  const { screenSize } = device;
  const [data, setdata] = useState({});
  const [loading, setLoading] = useState(false);
  const [alertText, setAlertText] = useState('');
  const [open, setOpen] = useState(false);

  const validateAccount = useCallback(async () => {
    let resp;
    setLoading(true);
    resp = await getGlobal({ tmbservice: 'getFormularioPuntos' });

    if (resp.typeMessage === 'error') {
      if (resp.message === '498' || resp.message === '499') setSessionMessage(resp.message);
      setAlertText(resp.message);
      setOpen(true);
    } else {
      setdata(resp);
    }
    setLoading(false);
  }, [setSessionMessage]);

  const setFacebookUser = useCallback(
    async ({ socialData, redSocial }) => {
      const resp = await postGloba({
        tmbservice: 'postSeguirRedSocial',
        jsonBody: {
          usuario: socialData.name,
          redSocial: redSocial,
        },
      });

      const { messageCode } = resp;

      if (messageCode === 200) {
        validateAccount();
      } else {
        alert('Ocurrió un error, por favor intentalo de nuevo');
      }
    },
    [validateAccount],
  );

  useEffect(() => {
    validateAccount();
  }, [validateAccount]);

  return (
    <div>
      <Alert open={open} setOpen={setOpen} title='Mensaje del sistema' text={alertText} />
      <BannerTerrapuntosDetail screenSize={screenSize} />
      {(loading && (
        <div className={styles.container}>
          <Skeleton variant='rectangular' className={styles.loadingText} />
          <Skeleton variant='rectangular' className={styles.loadingText} />
          <Skeleton variant='rectangular' className={styles.loadingText} />
        </div>
      )) || (
        <div className={`${styles.container} ${styles[screenSize]}`}>
          <div className={`${styles.catalogContainer} ${styles[screenSize]}`}>
            <div className={styles.encabezado}>
              <label className={styles.textEncabezado}>PUNTOS ACUMULADOS</label>
            </div>

            <div className={styles.catalogContent}>
              <div
                className={styles.imageContainer}
                style={{
                  backgroundImage: `url(${(screenSize === 'phone' && urlImage) || urlImage})`,
                }}></div>
              <div className={styles.documentTitle}>
                Puntos disponibles:{' '}
                <span className={styles.textCont}>{data.puntosDisponibles}</span>
              </div>
            </div>
          </div>

          <div className={`${styles.catalogContainer} ${styles[screenSize]}`}>
            <div className={styles.encabezado}>
              <label className={styles.textEncabezado}>BALANCE DE PUNTOS</label>
            </div>
            <div className={styles.catalogContent}>
              <div className={styles.list}>
                <div
                  className={styles.imageList}
                  style={{
                    backgroundImage: `url(${
                      (screenSize === 'phone' && urlImageStar) || urlImageStar
                    })`,
                  }}></div>
                <div className={styles.listText}>
                  Puntos acumulados: <span>{data.puntosTotales}</span>
                </div>
              </div>
              <div className={styles.list}>
                <div
                  className={styles.imageList}
                  style={{
                    backgroundImage: `url(${
                      (screenSize === 'phone' && urlImageStar) || urlImageStar
                    })`,
                  }}></div>
                <div className={styles.listText}>
                  Puntos cambiados: <span>{data.puntosCambiados}</span>
                </div>
              </div>
              <div className={styles.list}>
                <div
                  className={styles.imageList}
                  style={{
                    backgroundImage: `url(${
                      (screenSize === 'phone' && urlImageStar) || urlImageStar
                    })`,
                  }}></div>
                <div className={styles.listText}>
                  Puntos por vencer: <span>{data.puntosPorVencer}</span>
                </div>
              </div>
            </div>
          </div>

          <div className={`${styles.catalogContainer} ${styles[screenSize]}`}>
            <div className={styles.encabezado}>
              <label className={styles.textEncabezado}>MIS DATOS</label>
            </div>
            <div className={styles.catalogContent}>
              <div className={styles.listSmall}>
                <div className={styles.listTextSmall}>
                  Nombre: <span className={styles.textContent}>{getCookie('kitName')}</span>
                </div>
              </div>

              {data.rfc !== 'XAXX010101000' && (
                <div className={styles.listSmall}>
                  <div className={styles.listTextSmall}>
                    RFC: <span className={styles.textContent}>{data.rfc}</span>
                  </div>
                </div>
              )}

              <div className={styles.listSmall}>
                <div className={styles.listTextSmall}>
                  Correo electrónico: <span className={styles.textContent}>{data.mail}</span>
                </div>
              </div>

              <div className={styles.listSmall}>
                <div className={styles.listTextSmall}>
                  Télefono móvil: <span className={styles.textContent}>{data.celular}</span>
                </div>
              </div>
              <div className={styles.listSmall}>
                <div className={styles.listTextSmall}>
                  Fecha de registro:
                  <span className={styles.textContent}> {data.fechaRegistro}</span>
                </div>
              </div>

              {(data && !data?.EstatusSeguimientofacebook && !data?.facebook && (
                <div className={styles.listSmall}>
                  <LoginSocialFacebook
                    appId='178714698273373'
                    onResolve={(response) => {
                      setFacebookUser({ socialData: response.data, redSocial: 'Facebook' });
                    }}
                    onReject={(response) => {
                      console.log(response);
                    }}>
                    <div className={styles.facebookButton}>
                      <img src={FBLogo} alt='fb-logo' className={styles.socialLogo} />
                      Iniciar sesión
                    </div>
                  </LoginSocialFacebook>
                </div>
              )) || (
                <div className={styles.listSmall}>
                  <div className={styles.listTextSmall}>
                    Facebook:{' '}
                    <span className={styles.textContent}>
                      {data?.facebook ? 'Siguiendo' : data.EstatusSeguimientofacebook}
                    </span>
                  </div>
                </div>
              )}
            </div>
          </div>
        </div>
      )}
    </div>
  );
}
